"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Grid = void 0;
var _react = _interopRequireWildcard(require("react"));
var _useResponsiveConfig = require("../hooks/useResponsiveConfig");
var _gap = require("../styles/gap");
var _grid = require("../styles/grid");
var _responsive = require("../styles/responsive");
var _linaria = require("../utils/linaria");
var _Box = require("./Box");
const _excluded = ["children", "responsiveConfig", "columns", "templateColumns", "columnMin", "columnMax", "style", "className", "gap"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
const Grid = /*#__PURE__*/(0, _react.memo)( /*#__PURE__*/(0, _react.forwardRef)(function Grid(_ref, forwardedRef) {
  let children = _ref.children,
    responsiveConfig = _ref.responsiveConfig,
    columnsProp = _ref.columns,
    templateColumns = _ref.templateColumns,
    columnMin = _ref.columnMin,
    _ref$columnMax = _ref.columnMax,
    columnMax = _ref$columnMax === void 0 ? '1fr' : _ref$columnMax,
    style = _ref.style,
    className = _ref.className,
    gap = _ref.gap,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const responsiveStyleClassNames = (0, _useResponsiveConfig.useResponsiveConfig)(responsiveConfig);
  const columnsKey = columnsProp && `columns-${columnsProp}`;
  const columnsClassName = columnsKey && _grid.columns[columnsKey];
  const isImplicit = !columnsProp && !templateColumns && !!columnMin;
  const styles = (0, _react.useMemo)(() => {
    if (templateColumns) {
      return {
        gridTemplateColumns: templateColumns
      };
    }
    if (isImplicit) {
      return {
        gridTemplateColumns: `repeat(auto-fill, minmax(${columnMin}, ${columnMax}))`
      };
    }
    return style;
  }, [columnMax, columnMin, style, isImplicit, templateColumns]);
  return /*#__PURE__*/_react.default.createElement(_Box.Box, _extends({
    ref: forwardedRef,
    className: (0, _linaria.cx)(columnsProp && columnsClassName, gap && _gap.gap[gap], responsiveConfig && _responsive.responsiveClassName, responsiveStyleClassNames, className),
    display: "grid",
    style: styles
  }, props), children);
}));
exports.Grid = Grid;
Grid.displayName = 'Grid';